import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from '@nuxtjs/composition-api';
import MomentCard from '~/components/Collections/MomentCard.vue';
import { IProject } from '~/types/project';
import { ECollectionCtaType } from '~/types/collections';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectMysteryBoxUpsell',
  props: {
    project: null
  },
  setup(__props: any) {

const props = __props as {
  project: IProject;
};



const { $vuetify } = useContext();

const mysteryBoxUpsellCta = computed(() => {
  return props.project.ctaCards?.find(
    (card) => card.type === ECollectionCtaType.MB_UPSELL,
  );
});

const ctaImgDims = computed(() => {
  return $vuetify?.breakpoint?.smAndUp ? 110 : 90;
});

return { __sfc: true,props, $vuetify, mysteryBoxUpsellCta, ctaImgDims, MomentCard }
}

})